var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class PlanarHbSeries {
    constructor(socket, log) {
        this.socket = socket;
        this.displayFreeze = false;
        this.power = false;
        this.videoSelection = '09'; // HDMI 1
        this.volume = '32'; // hex value
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'freeze',
                regExp: /kz\s+\d{2}\s+(00|01|FF)/i,
                callback: (match) => {
                    if (match[1].toUpperCase() !== 'FF') {
                        this.displayFreeze = match[1] === '01';
                    }
                    this.socket.send(`kz 00 ${this.displayFreeze ? '01' : '00'}`);
                },
            },
            {
                name: 'power',
                regExp: /ka\s+\d{2}\s+(00|01|FF)/i,
                callback: (match) => {
                    if (match[1].toUpperCase() !== 'FF') {
                        this.power = match[1] === '01';
                    }
                    this.socket.send(`ka 00 ${this.power ? '01' : '00'}`);
                },
            },
            {
                name: 'videoInput',
                regExp: /kb\s+\d{2}\s+([0-9a-f]{2})/i,
                callback: (match) => {
                    if (match[1].toUpperCase() !== 'FF') {
                        this.videoSelection = match[1];
                    }
                    this.socket.send(`kb 00 ${this.videoSelection}`);
                },
            },
            {
                name: 'volume',
                regExp: /kf\s+\d{2}\s+([0-9a-f]+)/i,
                callback: (match) => {
                    if (match[1].toUpperCase() !== 'FF') {
                        this.volume = match[1];
                    }
                    this.socket.send(`kf 00 ${this.volume}`);
                },
            },
            {
                name: 'volumeMute',
                regExp: /ke\s+\d{2}\s+(00|01|FF)/i,
                callback: (match) => {
                    if (match[1].toUpperCase() !== 'FF') {
                        this.volumeMute = match[1] === '01';
                    }
                    this.socket.send(`ke 00 ${this.volumeMute ? '01' : '00'}`);
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 4660 || this.power);
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 4660 || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || parseInt(code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '09';
    }
}
PlanarHbSeries.emulatorType = 'socketEmulator';
PlanarHbSeries.key = '-NTEzW5u1WpyO0dyLBa8';
